export interface IExpectedSkillLevelProps {
  designation: string;
  tier: string;
  headers?: string[];
  data: Array<{
    skill: string;
    level: string;
    description: string;
  }>;
}

function ExpectedSkillLevel({
  designation,
  tier,
  headers = ['Skills', 'Expected Level', 'Description'],
  data,
}: IExpectedSkillLevelProps) {
  return (
    <>
      <div className="text-lg font-semibold mb-4">
        Expected Skill Competency Level for{' '}
        <span className="text-[#3C91E6]">
          {designation} (Tier {tier})
        </span>
      </div>
      {data.length > 0 ? (
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-50">
              {headers.map((header, index) => (
                <th key={index} className="border p-3 text-left">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td className="border font-bold p-3">{item.skill}</td>
                <td className="border p-3">Level {item.level}</td>
                <td className="border p-3">
                  {item.description.split('•').map((desc, idx) => {
                    const trimmedDesc = desc.trim();
                    return trimmedDesc ? (
                      <div key={idx}>{trimmedDesc}</div>
                    ) : null;
                  })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-gray-400 italic p-4 text-center border rounded-lg">
          No skill competency data available
        </div>
      )}
    </>
  );
}

export default ExpectedSkillLevel;
